import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const schoolResourceDeleteApi = createAsyncThunk(
    'auth/schoolResources/delete',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.delete(apiRoutes.schoolProcessAction(`${id}`, 1))
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const schoolResourceDeleteSlice = createSlice({
    name: 'schoolResource delete',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(schoolResourceDeleteApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(schoolResourceDeleteApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(schoolResourceDeleteApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const schoolResourceDeleteReducer = schoolResourceDeleteSlice.reducer